let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("gvznw"), load("kn1TN")]).then(() => parcelRequire('2Brjf'));